module.exports = __webpack_public_path__ + "static/media/integrations.active.77745be9.svg";